export function newPop(name, url, left, top, width, height, toolbar, menubar, statusbar, scrollbar, resizable)
{
	const toolbar_str = toolbar ? 'yes' : 'no';
	const menubar_str = menubar ? 'yes' : 'no';
	const statusbar_str = statusbar ? 'yes' : 'no';
	const scrollbar_str = scrollbar ? 'yes' : 'no';
	const resizable_str = resizable ? 'yes' : 'no';
    if(left ==='' && top==='')
    {
        left = (screen.width - width) / 2;
        top  = (screen.height - height) / 2;
    }
	const winprops = 'left='+left+',top='+top+',width='+width+',height='+height+',toolbar='+toolbar_str+',menubar='+menubar_str+',status='+statusbar_str+',scrollbars='+scrollbar_str+',resizable='+resizable_str
	window.open(url, name, winprops)
	//if (parseInt(navigator.appVersion) >= 4) { win.window.focus(); }
}
